import OMath from '@/utils/math'
import {mapActions, mapState} from 'vuex'
import dayjs from 'dayjs'

export default {
  computed: {
    ...mapState('common', [
      'allOptions', 'allOptions11', 'allOptions12','allOptions13', 'allOptions15','allOptions21', 'allOptions22', 'allOptions23','allOptions24', 'allOptions25', 'allOptions26','allOptions29',
      'allOptions27','allOptions31','globalOptions', 'customerOptions','bankList','extraBenefitsOption','specialOptions','smeOptions81','smeOptions82','smeOptions83','smeOptions84','smeOptions85',
      'smeOptions86','smeOptions88','carClassOption','allOptions30','newSMEOptions','ocrTypeOptions']),
    ...mapState('copy',['keyAltDownCopy']),
    crDisableBenefits(){
      return{
        64: [32],   // 选中64时禁用23
        32: [64],   // 选中23时禁用64
        256: [128], // 选中256时禁用124
        128: [256]  // 选中124时禁用256
      }
    },
    endorseChangeTypeOptions(){
      return[
        {
          name: 'Change Car',
          id: 1
        },
        {
          name: 'Others',
          id: 2
        },
      ]
    },
    quoteStatusColor(){
      return {
        void: ['Void'],
        pending: ['Pending', 'Ready for Application'],
        yellow: ['Sent', 'Waiting for CS'],
        purple: ['Waiting for Signature', 'Waiting For Payment'],
        green: ['Final Quote'],
        orange: ['Payment Need Approval']
      }
    },
    customerTypeOptions(){
      return[
        {
          name: 'Member',
          id: 0
        },
        {
          name: 'Guest',
          id: 1
        },
      ]
    },
    noClaimStatusList(){
      return[
        {
          name:'Pending',
          id:1,
        },
        {
          name:'Redeemed',
          id:2,
        },
        {
          name:'Reject',
          id:3,
        },
      ]
    },
    quoteStatusOptions(){
      return[
        {
          name: 'Quoted',
          id: 1
        },
        {
          name: 'Rejected',
          id: 0
        },
      ]
    },
    selectSMEList() {
      return [
        {
          id: 89,
          name: 'SME'
        },
        {
          id: 79,
          name: 'C.A.R'
        }
      ]
    },
    hdSearchTypeList(){
      return[
        {
          name: 'Credit',
          id: 'price'
        },
        {
          name: 'Insurer',
          id: 'company'
        },
        {
          name: 'Policy No.',
          id: 'pcy_no'
        },
        {
          name: 'Ref.',
          id: 'order_sn'
        },
      ]
    },
    searchTypeList(){
      return[
        {
          name: 'All',
          id: ''
        },

        {
          name: 'Contact',
          id: 'contact'
        },
        {
          name: 'Cover Note No.',
          id: 'cvr_nt_no'
        },
        {
          name: 'Endorsement No.',
          id: 'endorser_no'
        },
        {
          name: 'HKID/BR/Passport',
          id: 'id_no'
        },
        {
          name: 'Policy No.',
          id: 'pcy_no'
        },
        {
          name: 'Policyholder',
          id: 'policyholder'
        },
        {
          name: 'Reference No.',
          id: 'order_sn'
        },
        {
          name: 'Referrer',
          id: 'referrer'
        },
        {
          name: 'VRN',
          id: 'vrd'
        },
      ]
    },
    product_setting_type(){
      let {product_setting_type} = this.globalOptions||{}
      return product_setting_type||[]
    },
    product_setting_way(){
      let {product_setting_way} = this.globalOptions||{}
      return product_setting_way||[]
    },
    product_classes(){
      let {product_classes} = this.globalOptions||{}
      return product_classes||[]
    },
    product_company(){
      let {product_classes,company} = this.globalOptions||{}
      let new_company = company.filter(item=>item.id!=0)
      let arr = new_company.reduce((result, item)=>{
        result.push({company_id:item.id,company_name:item.name})
        return result
      },[])
      return arr
    },
    auto_renewal_tag_list() {
      return [
        {
          id:1,
          name:'Pending'
        },
        {
          id:2,
          name:'Success'
        },
        {
          id:4,
          name:'Sign and Pay'
        },
        {
          id:3,
          name:'Invalid'
        },
      ]
    },
    auto_renewal_list() {
      return [
        {
          id:1,
          name:'Client ON'
        },
        {
          id:2,
          name:'Client OFF'
        }
      ]
    },
    carbombStatutList(){
      return [
        {
          id: 1,
          name: 'Pending'
        },
        {
          id:2,
          name: 'Published'
        },
        {
          id: 3,
          name: 'Hidden'
        },
        {
          id: 4,
          name: 'Declined'
        },
      ]
    },
    bomb_rating_list(){
      return [
        {
          id: 0,
          name: 0
        },
        {
          id: 1,
          name: 1
        },
        {
          id:2,
          name: 2
        },
        {
          id: 3,
          name: 3
        },
        {
          id: 4,
          name: 4
        },
        {
          id: 5,
          name: 5
        },
      ]
    },
    voteList() {
      return [
        {
          id: 1,
          name: 'Add'
        },
        {
          id: 0,
          name: 'SubStract'
        }
      ]
    },
    publishList() {
      return [
        {
          id: 1,
          name: 'Yes'
        },
        {
          id: 0,
          name: 'OFF'
        }
      ]
    },
    user_agreement_option(){
      let {user_agreement_1 } = this.globalOptions||{}
      return user_agreement_1|| []
    },
    cashout_list(){
      return [
        {
          id:1,
          name:'Credit Card Transfer',
        },
        {
          id:2,
          name:'Bank Transfer',
        }
      ]
    },
    vip_level_list(){
      return [
        {
          id:0,
          name:'Pro',
        },
        {
          id:1,
          name:'Pro Plus',
        }
      ]
    },
    serverTypeIcon(){
      return [
        {
          id: 1,
          type: 'HoldCover',
          name: require('@/assets/images/icon/hc.png'),
        },
        {
          id: 2,
          type:'Fina',
          name: require('@/assets/images/icon/Fina.png')
        },
      ]
    },
    agencyIcon(){
      return [
        {
          id: 6,
          name: require('@/assets/algo.png'),
        },
        {
          id: 2,
          name: require('@/assets/ena.png')
        },
        {
          id: 3,
          name: require('@/assets/rnb.png')
        },
        {
          id: 9,
          name: require('@/assets/tf.png')
        }
      ]
    },
    agencySmallIcon(){
      let {cs_team =[]} = this.globalOptions||{}
      return cs_team.reduce((result, item)=>{
        result.push({name:item.agency_icon,id:item.id})
        return result
      },[])
    },
    serverTypeOption(){
      return [
        {
          id: '',
          name: 'All',
        },
        {
          id: 1,
          name: 'HoldCover',
        },
        {
          id: 2,
          name:'Fina'
        },
      ]
    },
    petNumOptions() {
      return [
        {
          id: 1,
          name: 1
        },
        {
          id: 2,
          name: 2
        },
        {
          id:3,
          name: 3
        },
        {
          id: 4,
          name: 4
        },
        {
          id: 5,
          name: 5
        },
      ]
    },
    SMENatureTime_81(){
      let {sme_catering_options }  = this.globalOptions||{}
      let {business_nature} = sme_catering_options||{}
      return business_nature||[]
    },
    SMEJobRoleOption_81(){
      let {sme_catering_options }  = this.globalOptions||{}
      let {job_role} = sme_catering_options||{}
      return job_role||[]
    },
    SMENatureTime_82(){
      let {sme_office_options }  = this.globalOptions||{}
      let {business_nature} = sme_office_options||{}
      return business_nature||[]
    },
    SMEJobRoleOption_82(){
      let {sme_office_options }  = this.globalOptions||{}
      let {job_role} = sme_office_options||{}
      return job_role||[]
    },
    SMENatureTime_83(){
      let {sme_retail_shop_options }  = this.globalOptions||{}
      let {business_nature} = sme_retail_shop_options||{}
      return business_nature||[]
    },
    SMEJobRoleOption_83(){
      let {sme_retail_shop_options }  = this.globalOptions||{}
      let {job_role} = sme_retail_shop_options||{}
      return job_role||[]
    },
    SMEJobRoleOption_89(){
      let {sme_other_options} = this.globalOptions||{}
      let {job_role} = sme_other_options||{}
      return job_role||[]
    },
    smeCoverageContentOption(){
      return[
        {
          id: 1,
          name:'Cal'
        },
        {
          id: 2,
          name:'Fixed'
        },
      ]
    },
    newSmeProductOption(){
      return[
        {
          icon: 'utensils',
          id: 81,
          name: 'Catering',
          typeList: ['Company']
        },
        {
          icon: 'door-closed',
          id: 82,
          name: 'Pure Office',
          typeList: ['Company']
        },
        {
          icon: 'store',
          name: 'Retail Shop',
          typeList: ['Company'],
          id: 83
        },
        {
          icon: 'comment-dots',
          name: 'Other',
          typeList: ['Company'],
          id: 89
        },
      ]
    },
    cvr_nt_isrd_days(){
      let {cover_note_effective=[]}  = this.globalOptions||{}
      return cover_note_effective
    },
    newSmeCARProductOption(){
      return[
        {
          icon: 'briefcase',
          id: 79,
          name: 'Contracts All Risks',
          typeList: ['Company']
        },
      ]
    },
    makeStatusOptions() {
      return [
        {
          id: 1,
          name: 'Enabled'
        },
        {
          id: 0,
          name: 'Disabled'
        }
      ]
    },
    claimOption() {
      return [
        {
          id: 1,
          name: 'Claim Tickets'
        },
        {
          id: 2,
          name: 'Redirect to Insurer'
        },
        {
          id: 3,
          name: 'Both'
        }
      ]
    },
    carClassInsureList(){
      let {insurer} = this.carClassOption
      let arr =[{id:'',name:'All'}]
      return [...arr,...insurer]
    },
    carClassMakeList(){
      let {make} = this.carClassOption
      let arr =[{id:'',name:'All'}]
      return [...arr,...make]
    },
    carClasslist(){
      return[
        // {id:0,name:'Class List',path:'class-list'},
        {id:3,name:'Make Model',path:'manage-make'},
        {id:1,name:'Grade List',path:'manage-class'},
        // {id:2,name:'Manage Model',path:'manage-model'},

      ]
    },
    reportList(){
      return [
        {
          title:'User Report',
          list:[
            {
              name:'Sign up',
              path:'/marketing/sign-up'
            },
            {
              name:'Professional User',
              path:'/marketing/professional-user'
            },
            {
              name:'Client Profile',
              path:'/marketing/client-profile'
            },
          ]
        },
        {
          title:'Policy Report',
          list:[
            {
              name:'Policy MGM',
              path:'/marketing/policy-mgm'
            },
            {
              name:'Private Car',
              path:'/marketing/private-car'
            },
            {
              name:'Motorcycle',
              path:'/marketing/motorcycle'
            },
            {
              name:'Travel',
              path:'/marketing/travel'
            },
            {
              name:'All Policy',
              path:'/marketing/all-policy'
            },
          ]
        },
        {
          title:'Other Report',
          list:[
            {
              name:'Quick Quote Report',
              path:'/administration/quick/report'
            },
            {
              name:'Refer Case/SME Ticket Report',
              path:'/administration/ticket/report'
            },
            {
              name:'Link Report',
              path:'/administration/linkreport'
            },
            {
              name:'Blog Ad Report',
              path:'/admin-cms/blog-ad'
            },
          ]
        }
      ]
    },
    sendList() {
      return [
        {
          id: 1,
          name: 'SMS'
        },
        {
          id: 2,
          name: 'Email'
        },
        {
          id: 3,
          name: 'Both'
        },
      ]
    },
    smeYesNoOptions() {
      return [
        {
          id: 1,
          name: 'Yes'
        },
        {
          id: 2,
          name: 'No'
        }
      ]
    },
    smeRequiredOptions() {
      return [
        {
          id: 1,
          name: 'Required'
        },
        {
          id: 2,
          name: 'Not Required'
        }
      ]
    },
    assigneeList(){
      const { assignee = [] } = this.globalOptions
      return  assignee
    },
    langList() {
      return [
        {
          id:'zh-HK',
          name:'繁體中文'
        },
        {
          id:'en-US',
          name:'English'
        },
      ]
    },
    clientOptions() {
      return [
        {
          id:1,
          name:'Mobile'
        },
        {
          id:2,
          name:'Desktop'
        },
        {
          id:3,
          name:'App'
        },
      ]
    },
    userTOptions() {
      return [
        {
          id:3,
          name:'Guest'
        },
        {
          id:1,
          name:'Personal'
        },
        {
          id:2,
          name:'Company'
        },
      ]
    },
    quoteTypeOptions() {
      return [
        {
          id:0,
          name:'New'
        },
        {
          id:1,
          name:'Guest'
        },
        {
          id:2,
          name:'Renew'
        },
      ]
    },
    quoteStautsOption() {
      let {cs_quote_status} = this.globalOptions||{}
      return cs_quote_status||[]
    },
    agencyStatusOption() {
      let {agency} = this.globalOptions||{}
      return agency||[]
    },
    applicationTypeOption() {
      let {application_type} = this.globalOptions||{}
      return application_type||[]
    },
    answerList() {
      return [
        {
          id:1,
          name:'Confirmed'
        },
        {
          id:2,
          name:'Part of the Conditions are fulfilled'
        },
        {
          id:0,
          name:'-'
        },
      ]
    },
    dobOptions() {
      const year = new Date().getFullYear()
      let list = []
      for(let i = year; i >= 1920; i--) {
        list.push({
          id: i,
          name: i
        })
      }
      return list
    },
    userTypeOptions() {
      return [
        {
          name: 'Personal',
          id: 1
        },
        {
          name: 'Company',
          id: 2
        }
      ]
    },

    statusOption() {
      return[{
        name: 'Active',
        id: '1'
      },
      {
        name: 'Pending',
        id: '2'
      },
      {
        name: 'Banned',
        id: '0'
      },
      // {
      //   name: 'Need Approval',
      //   id: '3'
      // }
      ]
    },
    tagsOption() {
      return[
        {
          name: 'Need Approval',
          id: '0'
        },
        {
          name: 'Need Approval',
          id: '3'
        }
      ]
    },
    industryTypeOptions() {
      return [
        {
          id: 2001,
          name: 'Catering'
        },
        {
          id: 2101,
          name: 'Pure Office'
        },
        {
          id: 2201,
          name: 'Retail Shop'
        },
        {
          id: 2301,
          name: 'Beauty Center'
        },
        {
          id: 2401,
          name: 'Education Center'
        },
        {
          id: 2501,
          name: 'Hair Salon'
        },
        {
          id: 2601,
          name: 'Warehouse'
        },
        {
          id: 2701,
          name: 'Medical Center'
        },
      ]
    },
    // 產品類型
    productTypeOptions() {
      return [
        {
          name: 'Motor',//发动机
          id: 11
        },
        {
          name: 'Domestic Helper',//家务助理
          id: 12
        },
        {
          name: 'Working Holiday',//打工度假
          id: 13
        },
        {
          name: 'Travel',//旅行
          id: 14
        },
        {
          name: 'Interior Decoration',//室内装饰
          id: 15
        },
        {
          name: 'Overseas Student',//留学生
          id: 16
        },
        {
          name: 'Home',//家居与消防
          id: 17
        },
        {
          name: 'Fire',//家居与消防
          id: 20
        },
        {
          name: 'Pet',//宠物
          id: 22
        },
        {
          name: 'Personal Accident',//人身意外
          id: 18
        },
        {
          name: 'Business Package',//医疗
          id: 80
        },
        // {
        //   name: 'Exhibition',//展览
        //   id: 20
        // }
      ]
    },
    //保險類型
    insurerOptions() {
      // return [
      //   {
      //     name: 'Tokio Marine',
      //     id: 17
      //   },
      //   {
      //     name: 'AIG',
      //     id: 18
      //   },
      //   {
      //     name: 'QBE',
      //     id: 19
      //   },
      //   {
      //     name: 'Tai Ping',
      //     id: 20
      //   },
      // ]
      const { company = [] } = this.globalOptions
      return company.filter(item => item.id)
    },
    insurerAllOptions(){
      const { cs_company = [] } = this.globalOptions || {}
      return cs_company.filter(item => item.id)
    },
    //验证身份 香港居民身份证/护照
    personalIdTypOptions() {
      return [
        {
          name: 'HKID',
          id: 1
        },
        {
          name: 'Passport',
          id: 2
        },
      ]
    },
    idTypeOptions() {
      return [
        {
          name: 'HKID',
          id: 1
        },
        {
          name: 'Passport',
          id: 2
        },
        {
          name: 'BR',
          id: 3
        }
      ]
    },
    genderOptions() {
      return [
        {
          name: 'Male',
          id: 1
        },
        {
          name: 'Female',
          id: 2
        }
      ]
    },
    // 用途
    usageOptions() {
      return [
        {
          name: 'Private Use',//私人
          id: 1
        },
        {
          name: 'Commercial Use',//商业用途
          id: 2
        }
      ]
    },
    compassionate_visit_type() {
      return [
        {
          name: '1 Way',//私人
          id: 1
        },
        {
          name: '2 Ways',//商业用途
          id: 2
        }
      ]
    },
    numberFourOptions() {
      return [
        {
          id: 1,
          name: 1
        },
        {
          id: 2,
          name: 2
        },
        {
          id: 3,
          name: 3
        },
        {
          id: 4,
          name: 4
        }
      ]
    },
    numberTwoOptions() {
      return [
        {
          id: 1,
          name: 1
        },
        {
          id: 2,
          name: 2
        },
      ]
    },
    hzmbPersonOptions() {
      return [
        // {
        //   id: 1,
        //   name: 1
        // },
        {
          id: 2,
          name: 2
        },
        {
          id: 3,
          name: 3
        },
        {
          id: 4,
          name: 4
        },
        {
          id: 5,
          name: 5
        },
        {
          id: 6,
          name: 6
        },
        {
          id: 7,
          name: 7
        },
        {
          id: 8,
          name: 8
        },
      ]
    },
    hzmbBenefitsOptions(){
      return [
        {
          id:1,
          name:'機動車第三者責任險',
        },
        {
          id:2,
          name:'機動車第三者附加醫保外醫療費用責任險',
        }
      ]
    },
    yesNoOptions() {
      return [
        {
          id: 1,
          name: 'Yes'
        },
        {
          id: 0,
          name: 'No'
        }
      ]
    },
    agreeOptions() {
      return [
        {
          id: 1,
          name: 'Agree'
        },
        {
          id: 0,
          name: 'Disagree'
        }
      ]
    },
    dimensionGlass() {
      return [
        {
          id: 1,
          name: 'cm'
        },
        {
          id: 0,
          name: 'ft'
        }
      ]
    },
    yesNoOptionsDirver() {
      return [
        {
          id: 2,
          name: 'Yes'
        },
        {
          id: 0,
          name: 'No'
        }
      ]
    },
    acciOptions() {
      return [
        {
          id: 1,
          name: 'No Accident'
        },
        {
          id: 0,
          name: 'Had Accident(s)'
        },
      ]
    },
    deductOptions() {
      return [
        {
          id: 1,
          name: 'No Point(s) Deducted'
        },
        {
          id: 0,
          name: 'Point(s) Deducted '
        },
      ]
    },
    modifiedOptions() {
      return [
        {
          id: 0,
          name: 'No Modification'
        },
        {
          id: 1,
          name: 'Modified'
        },
      ]
    },
    installOptions() {
      return [
        {
          id: 1,
          name: 'Installed'
        },
        {
          id: 0,
          name: 'Not Installed'
        },
      ]
    },
    // 一样的，標記非必選吧
    yesNo2Options() {
      return [
        {
          id: 1,
          name: 'Yes'
        },
        {
          id: 0,
          name: 'No'
        }
      ]
    },
    allCoverTypeOptions() {
      return [
        {
          id: 1,
          name: 'Third Party'//第三方
        },
        {
          id: 2,
          name: 'Comprehensive'//全面
        },
        {
          id: 0,
          name: 'All'
        },
      ]
    },
    CarCoverTypeOptions() {
      return [
        {
          id: 1,
          name: 'Third Party'//第三方
        },
        {
          id: 2,
          name: 'Comprehensive'//全面
        },
      ]
    },
    coverTypeOptions() {
      return [
        {
          id: 1,
          name: 'Third Party'
        },
        {
          id: 2,
          name: 'Comprehensive'
        },
      ]
    },
    coverThirdTypeOptions() {
      return [
        {
          id: 1,
          name: 'Third Party'
        },
      ]
    },
    motorClassOptions() {
      return [
        {
          id: 14,
          name: 'Motorcycle'//摩托车
        },
        {
          id: 11,
          name: 'Private Car'//私家车
        },
        {
          id: 12,
          name: 'Commercial Vehicle'//商用车
        },
        {
          id: 13,
          name: 'Motor Trade'//
        },
      ]
    },
    classOptions() {
      return [
        {
          id: 11,
          name: 'Private Car'
        },
        {
          id: 12,
          name: 'Commercial Vehicle'
        },
        {
          id: 14,
          name: 'Motorcycle'
        },
        {
          id: 13,
          name: 'Motor Trade'
        },
        {
          id: 15,
          name: 'HZMB'
        },
        {
          id: 21,
          name: 'Domestic Helper'
        },
        {
          id: 22,
          name: 'Working Holiday'
        },
        {
          id: 23,
          name: 'Travel'
        },
        {
          id: 24,
          name: 'Interior Decoration'//室内装饰
        },
        {
          id: 25,
          name: 'Overseas Student'
        },
        {
          id: 26,
          name: 'Home'
        },
        {
          id: 27,
          name: 'Personal Accident'
        },
        {
          id: 29,
          name: 'Fire'
        },
        {
          id: 31,
          name: 'Pets'
        },
        {
          id: 81,
          name: 'Catering'
        },
        {
          id: 82,
          name: 'Pure Office'
        },
        {
          id: 83,
          name: 'Retail Shop'
        },
        {
          id: 84,
          name: 'Beauty Center'
        },
        {
          id: 85,
          name: 'Education Center'
        },
        {
          id: 86,
          name: 'Hair Salon'
        },
        {
          id: 88,
          name: 'Medical Center'
        },
        {
          id: 79,
          name: 'Contracts All Risks'
        },
        {
          name: 'Other',
          id: 89
        },
      ]
    },
    classChinaOptions() {
      return [
        {
          id: 11,
          name: '私家車'
        },
        {
          id: 12,
          name: '商用車'
        },
        {
          id: 14,
          name: '電單車'
        },
        {
          id: 21,
          name: '家傭'
        },
        {
          id: 22,
          name: '工作假期'
        },
        {
          id: 23,
          name: '旅遊'
        },
        {
          id: 24,
          name: '室内装饰'//室内装饰
        },
        {
          id: 25,
          name: '海外留學生'
        },
        {
          id: 26,
          name: '家居'
        },
        {
          id: 27,
          name: '個人意外'
        },
        {
          id: 29,
          name: '火險'
        },
        {
          id: 31,
          name: '寵物'
        },
        {
          id: 81,
          name: '餐廳'
        },
        {
          id: 82,
          name: '辦公室'
        },
        {
          id: 83,
          name: '零售商店'
        },
        {
          id: 84,
          name: '美容院'
        },
        {
          id: 85,
          name: '教育中心'
        },
        {
          id: 86,
          name: '髮型屋'
        },
        {
          id: 88,
          name: '醫療中心/診所'
        },
      ]
    },
    ticketTypeOptions() {
      return [
        {
          name: 'General',//一般,正常？？？
          id: 1
        },
        {
          name: 'Refer Case',//案例
          id: 2
        },
        {
          name: 'Endorsement',//认可
          id: 3
        },
        {
          name: 'HD Transfer',//信用转账
          id: 4
        },
        {
          name: 'Business',//商用
          id: 5
        },
        {
          name: 'Claims',
          id: 6
        },
        {
          name: 'Refer Request',
          id: 7
        }
      ]
    },
    ticketListOptions() {
      return [
        {
          name: 'General',//一般,正常？？？
          id: 1
        },
        {
          name: 'Refer Case',//案例
          id: 2
        },
        {
          name: 'Endorsement',//认可
          id: 3
        },
        {
          name: 'HD Transfer',//信用转账
          id: 4
        },
        {
          name: 'Special/SME',//商用
          id: 5
        },
        {
          name: 'Claims',
          id: 6
        },
        // {
        //   name: 'Refer Request',
        //   id: 7
        // }
      ]
    },
    statusTypeOptions() {
      return [
        {
          name: 'New',//一般,正常？？？
          id: 1
        },
        {
          name: 'Handling',//案例
          id: 2
        },
        {
          name: 'Resolved',//认可
          id: 3
        },
        {
          name: 'Void status',//认可
          id: 4
        }
      ]
    },
    statusAllTypeOptions() {
      return [
        {
          name: 'New',//一般,正常？？？
          id: 1
        },
        {
          name: 'Handling',//案例
          id: 2
        },
      ]
    },
    snoozeTypeOptions() {
      return [
        {
          name: 'Snoozed',//一般,正常？？？
          id: 1
        },
        {
          name: 'Not Snoozed',//案例
          id: 0
        },
      ]
    },
    titleOptions() {
      return [
        {
          name: 'Mr.',
          id: 1
        },
        // {
        //   name: 'Mrs.',
        //   id: 2
        // },
        {
          name: 'Miss.',
          id: 3
        },
        // {
        //   name: 'Miss.',
        //   id: 4
        // },
      ]
    },
    carTitleOptions() {
      return [
        {
          name: 'Mr.',
          id: 1
        },
        {
          name: 'Miss.',
          id: 3
        },
      ]
    },
    companys() {
      return [
        // {
        //   id: 11,
        //   name: 'Zurich',
        //   logo: require('@/assets/images/company/item-14@2x.png')
        // },
        // {
        //   id: 12,
        //   name: 'Ping An',
        //   logo: require('@/assets/images/company/item-13@2x.png')
        // },
        // {
        //   id: 13,
        //   name: 'Dasing',
        //   logo: require('@/assets/images/company/item-16@2x.png')
        // },
        // {
        //   id: 14,
        //   name: 'Trinity',
        //   logo: require('@/assets/images/company/item-9@2x.png')
        // },
        // {
        //   id: 15,
        //   name: 'AXA',
        //   logo: require('@/assets/images/company/item-1@2x.png')
        // },
        // {
        //   id: 16,
        //   name: 'CMI',
        //   // logo: require('@/assets/images/company/item-14@2x.png')
        // },
        // {
        //   id: 17,
        //   name: 'Tokio Marine',
        //   logo: require('@/assets/images/company/item-15@2x.png')
        // },
        // {
        //   id: 18,
        //   name: 'AIG',
        //   logo: require('@/assets/images/company/item-6@2x.png')
        // },
        // {
        //   id: 19,
        //   name: 'QBE',
        //   logo: require('@/assets/images/company/item-11@2x.png')
        // },
        // {
        //   id: 20,
        //   name: 'Tai Ping',
        //   logo: require('@/assets/images/company/item-12@2x.png')
        // },
        // {
        //   id: 21,
        //   name: 'Tai Ping',
        //   logo: require('@/assets/images/companyIcon/CHUBB.png')
        // },
        // {
        //   id: 22,
        //   name: 'Tai Ping',
        //   logo: require('@/assets/images/companyIcon/BLUE.png')
        // },
        // {
        //   id: 23,
        //   name: 'Tai Ping',
        //   logo: require('@/assets/images/companyIcon/GENERALI.png')
        // },
        // {
        //   id: 24,
        //   name: 'Tai Ping',
        //   logo: require('@/assets/images/companyIcon/ASIA.png')
        // },
        // {
        //   id: 25,
        //   name: 'FWD',
        //   logo: require('@/assets/images/companyIcon/FWD.png')
        // },
        // {
        //   id: 26,
        //   name: 'Target',
        //   logo: require('@/assets/images/companyIcon/Target.png')
        // },
      ]
    },
    companyLargeIcon() {
      return [
        {
          id: 11,
          name: 'Zurich',
          logo: require('@/assets/images/companyLarge/zurich.png')
        },
        {
          id: 12,
          name: 'Ping An',
          logo: require('@/assets/images/companyLarge/pingan.png')
        },
        {
          id: 13,
          name: 'Dasing',
          logo: require('@/assets/images/companyLarge/dahsing.png')
        },
        {
          id: 14,
          name: 'Trinity',
          logo: require('@/assets/images/companyLarge/trinity.png')
        },
        {
          id: 15,
          name: 'AXA',
          logo: require('@/assets/images/companyLarge/axa.png')
        },
        // {
        //   id: 16,
        //   name: 'CMI',
        //   logo: require('@/assets/images/companyLarge/cmi.png')
        // },
        {
          id: 17,
          name: 'Tokio Marine',
          logo: require('@/assets/images/companyLarge/tmf.png')
        },
        {
          id: 18,
          name: 'AIG',
          logo: require('@/assets/images/companyLarge/aig.png')
        },
        {
          id: 19,
          name: 'QBE',
          logo: require('@/assets/images/companyLarge/qbe.png')
        },
        {
          id: 20,
          name: 'Tai Ping',
          logo: require('@/assets/images/companyLarge/taiping.png')
        },
        {
          id: 21,
          name: 'Chubb',
          logo: require('@/assets/images/companyLarge/chubb.png')
        },
        {
          id: 22,
          name: 'Blue Cross',
          logo: require('@/assets/images/companyLarge/bluecross.png')
        },
        {
          id: 23,
          name: 'Generali',
          logo: require('@/assets/images/companyLarge/generali.png')
        },
        {
          id: 24,
          name: 'ASIA',
          logo: require('@/assets/images/companyLarge/asia.png')
        },
        {
          id: 25,
          name: 'FWD',
          logo: require('@/assets/images/companyLarge/fwd.png')
        },
        {
          id: 26,
          name: 'Target',
          logo: require('@/assets/images/companyLarge/target.png')
        },
        {
          id: 27,
          name: 'Allianz',
          logo: require('@/assets/images/companyLarge/allianz.png')
        },
        {
          id: 28,
          name: 'Starr',
          logo: require('@/assets/images/companyLarge/starr.png')
        },
        {
          id: 29,
          name: 'Bupa',
          logo: require('@/assets/images/companyLarge/bupa.png')
        },
        {
          id: 30,
          name: 'BOC Group',
          logo: require('@/assets/images/companyLarge/boc.png')
        },
        {
          id: 31,
          name: 'Allied World',
          logo: require('@/assets/images/companyLarge/alliedworld.png')
        },
        {
          id: 32,
          name: 'MSIG',
          logo: require('@/assets/images/companyLarge/msig.png')
        },
        {
          id: 33,
          name: 'Cigna',
          logo: require('@/assets/images/companyLarge/cigna.png')
        },
        {
          id: 34,
          name: 'Pacific Insurance',
          logo: require('@/assets/images/companyLarge/pacific.png')
        },
        {
          id: 35,
          name: 'Liberty',
          logo: require('@/assets/images/companyLarge/liberty.png')
        },
        {
          id: 36,
          name: 'Avo',
          logo: require('@/assets/images/companyLarge/avo.png')
        },
        {
          id: 37,
          name: 'Bolttech',
          logo: require('@/assets/images/companyLarge/Bolttech.png')
        },
        {
          id: 38,
          name: 'PICC',
          logo: require('@/assets/images/companyLarge/picc.png')
        },
        {
          id: 39,
          name: 'Ping An',
          logo: require('@/assets/images/companyLarge/pingan.png')
        },
        {
          id: 40,
          name: 'AXA',
          logo: require('@/assets/images/companyLarge/axa.png')
        },
        {
          id: 41,
          name: 'BOC',
          logo: require('@/assets/images/companyLarge/boc.png')
        },
        {
          id: 42,
          name: 'MSIG',
          logo: require('@/assets/images/companyLarge/msig.png')
        },
      ]
    },
    companySmallIcon() {
      return [
        {
          id: 11,
          name: 'Zurich',
          logo: require('@/assets/images/companySmall/zurich.png')
        },
        {
          id: 12,
          name: 'Ping An',
          logo: require('@/assets/images/companySmall/pingan.png')
        },
        {
          id: 13,
          name: 'Dasing',
          logo: require('@/assets/images/companySmall/dahsing.png')
        },
        {
          id: 14,
          name: 'Trinity',
          logo: require('@/assets/images/companySmall/trinity.png')
        },
        {
          id: 15,
          name: 'AXA',
          logo: require('@/assets/images/companySmall/axa.png')
        },
        {
          id: 16,
          name: 'CMI',
          logo: require('@/assets/images/companySmall/cmi.png')
        },
        {
          id: 17,
          name: 'Tokio Marine',
          logo: require('@/assets/images/companySmall/tmf.png')
        },
        {
          id: 18,
          name: 'AIG',
          logo: require('@/assets/images/companySmall/aig.png')
        },
        {
          id: 19,
          name: 'QBE',
          logo: require('@/assets/images/companySmall/qbe.png')
        },
        {
          id: 20,
          name: 'Tai Ping',
          logo: require('@/assets/images/companySmall/taiping.png')
        },
        {
          id: 21,
          name: 'Chubb',
          logo: require('@/assets/images/companySmall/chubb.png')
        },
        {
          id: 22,
          name: 'Blue Cross',
          logo: require('@/assets/images/companySmall/bluecross.png')
        },
        {
          id: 23,
          name: 'Generali',
          logo: require('@/assets/images/companySmall/generali.png')
        },
        {
          id: 24,
          name: 'ASIA',
          logo: require('@/assets/images/companySmall/asia.png')
        },
        {
          id: 25,
          name: 'FWD',
          logo: require('@/assets/images/companySmall/fwd.png')
        },
        {
          id: 26,
          name: 'Target',
          logo: require('@/assets/images/companySmall/target.png')
        },
        {
          id: 27,
          name: 'Allianz',
          logo: require('@/assets/images/companySmall/allianz.png')
        },
        {
          id: 28,
          name: 'Starr',
          logo: require('@/assets/images/companySmall/starr.png')
        },
        {
          id: 29,
          name: 'Bupa',
          logo: require('@/assets/images/companySmall/bupa.png')
        },
        {
          id: 30,
          name: 'BOC Group',
          logo: require('@/assets/images/companySmall/boc.png')
        },
        {
          id: 31,
          name: 'Allied World',
          logo: require('@/assets/images/companySmall/alliedworld.png')
        },
        {
          id: 32,
          name: 'MSIG',
          logo: require('@/assets/images/companySmall/msig.png')
        },
        {
          id: 33,
          name: 'Cigna',
          logo: require('@/assets/images/companySmall/cigna.png')
        },
        {
          id: 34,
          name: 'Pacific Insurance',
          logo: require('@/assets/images/companySmall/pacific.png')
        },
        {
          id: 35,
          name: 'Liberty',
          logo: require('@/assets/images/companySmall/liberty.png')
        },
        {
          id: 36,
          name: 'Avo',
          logo: require('@/assets/images/companySmall/avo.png')
        },
        {
          id: 37,
          name: 'Bolttech',
          logo: require('@/assets/images/companySmall/Bolttech.png')
        },
        {
          id: 38,
          name: 'PICC',
          logo: require('@/assets/images/companySmall/picc.png')
        },
        {
          id: 39,
          name: 'Ping An',
          logo: require('@/assets/images/companySmall/pingan.png')
        },
        {
          id: 40,
          name: 'AXA',
          logo: require('@/assets/images/companySmall/axa.png')
        },
        {
          id: 41,
          name: 'BOC Group',
          logo: require('@/assets/images/companySmall/boc.png')
        },
        {
          id: 42,
          name: 'MSIG',
          logo: require('@/assets/images/companySmall/msig.png')
        },
      ]
    },
    iconOptions(){
      return [
        {
          name: 'motorcycle',
          tip: 'Motorcycle',
          id: 14
        },
        {
          name: 'car',
          tip: 'Motor Trade',
          id: 13
        },
        {
          name: 'car-side',
          tip: 'PV',
          id: 11
        },
        {
          name: 'car-side',
          tip: 'PV',
          id: 15
        },
        {
          name: 'truck-moving',
          tip: 'CV',
          id: 12
        },
        {
          name: 'hand-sparkles',
          tip: 'Domestic Helper',
          id: 21
        },
        {
          name: 'paint-roller',
          tip: 'Interior',
          id: 24
        },
        {
          name: 'home',
          tip: 'Home Fire',
          id: 26
        },
        {
          name: 'plane',
          tip: 'Travel',
          id: 23
        },
        {
          name: 'atlas',
          tip: 'Oversea Student',
          id: 25
        },
        {
          name: 'street-view',
          tip: 'Working Holiday',
          id: 22
        },
        {
          name: 'fire-alt',
          tip: 'Fire',
          id: 29
        },
        {
          name: 'gamepad',
          tip: 'Drone',
          id: 30
        },
        {
          name: 'user-injured',
          tip: 'Accident' ,
          id: 27
        },
        {
          name: 'briefcase',
          tip: 'Business Package' ,
          id: 51
        },
        {
          name: 'paw',
          tip: 'Pet' ,
          id: 31
        },
        // {
        //   name: 'Stethoscope',
        //   tip: 'Medical' ,
        //   id: 2
        // },
        // {
        //   name: 'Briefcase',
        //   tip: 'Biz Pkg' ,
        //   id: 2
        // },
        {
          name: 'users',
          tip: 'EC' ,
          id: 52
        },
        {
          name: 'hard-hat',
          tip: 'Car' ,
          id: 53
        },
        {
          name: 'bus-alt',
          tip: 'Motor Fleet/Trade' ,
          id: 54
        },
        {
          name: 'bus-alt',
          tip: 'Motor Fleet/Trade' ,
          id: 55
        },
        {
          name: 'user-shield',
          tip: 'EB' ,
          id: 56
        },
        {
          name: 'user-shield',
          tip: 'EB' ,
          id: 57
        },
        {
          name: 'user-shield',
          tip: 'EB' ,
          id: 58
        },
        {
          name: 'sign',
          tip: 'Pub Liability' ,
          id: 59
        },
        {
          name: 'building',
          tip: 'Property' ,
          id: 60
        },
        {
          name: 'ship',
          tip: 'Marine Cargo' ,
          id: 61
        },
        {
          name: 'shield-alt',
          tip: 'other' ,
          id: 62
        },
        {
          name: 'virus',
          id: 90
        },
        {
          name: 'wallet',
          id: 91
        },
        {
          name: 'futbol',
          id: 92
        },
        {
          name: 'mobile-screen',
          id: 93
        },
        {
          name: 'utensils',
          id: 81
        },
        {
          name: 'door-closed',
          id: 82
        },
        {
          name: 'store',
          id: 83
        },
        {
          name: 'comment-dots',
          id: 89
        },
        {
          name: 'briefcase',
          id: 79
        },
      ]
    },
    contactPeriodOptions() {
      return [
        {
          name: 'Less than 3 months',
          id: 1
        },
        {
          name: 'More than 3 months',
          id: 2
        },
      ]
    },
    excessOptions() {
      return [
        {
          id: 2,
          name: 'sum insured whichever is the greater'
        },
        {
          id: 1,
          name: 'of loss whichever is the greater'
        },
      ]
    },
    decorationOptions() {
      return [
        {
          id: 1,
          name: 'of loss whichever is the greater'
        }
      ]
    },
    payOptions(){
      return [
        {
          id: 1,
          name: 'Bank Transfer'
        },
        {
          id: 3,
          name: 'Cheque '
        },
        {
          id: 6,
          name: 'FPS '
        },
        {
          id: 11,
          name: 'Direct pay to insurer'
        },
        {
          id: 10,
          name: 'Other '
        },
      ]
    },
    ticketOptions() {
      return {
        insuranceTypeOptions: [
          {
            name: 'Money Insurance',
            id: '9001'
          },
          {
            name: 'Products Liability',
            id: '9002'
          },
          {
            name: 'Contractor All Risks',
            id: '9003'
          },
          {
            name: 'Employee Compensation',
            id: '9008'
          },
          {
            name: 'Incorporated Owners Liability',
            id: '9004'
          },
          {
            name: 'Marine Cargo',
            id: '9005'
          },
          {
            name: 'Cyber Risks',
            id: '9006'
          },
          {
            name: 'Directors and Officers Liability',
            id: '9007'
          },
          {
            name: 'Group Life',
            id: '9009'
          },
          {
            name: 'Others',
            id: '9999'
          },
        ],
        allTypeOptions: [
          {
            name: 'Business Package',
            id: 1001
          },
          {
            name: 'Employee Compensation (E.C.)',
            id: 1101
          },
          {
            name: 'Contractors’ All Risks (C.A.R.)',
            id: 1601
          },
          {
            name: 'Motors Fleet / Motor Trade',
            id: 1500
          },
          {
            name: 'Employee Benefits (E.B.)',
            id: 1200
          },
          {
            name: 'Public Liability',
            id: 1301
          },
          {
            name: 'Property',
            id: 1401
          },
          {
            name: 'Marine Cargo',
            id: 1701
          },
          {
            name: 'Others',
            id: 9000
          },
          {
            name: 'Motors Fleet',
            id: 1501
          },
          {
            name: 'Motor Trade',
            id: 1502
          },
          {
            name: 'Group Business Travel',
            id: 1201
          },
          {
            name: 'Group Personal Accident',
            id: 1202
          },
          {
            name: 'Group Medical',
            id: 1203
          },
        ],
        insureTypeOptions: [
          {
            name: 'Business Package',
            id: 1001,//1001
          },
          {
            name: 'Employee Compensation (E.C.)',
            id: 1101,//1101
          },
          {
            name: 'Contractors’ All Risks (C.A.R.)',
            id: 1601 //1601
          },
          {
            name: 'Motors Fleet / Motor Trade',
            id: 1500
          },
          {
            name: 'Employee Benefits (E.B.)',
            id: 1200 //1200
          },
          {
            name: 'Public Liability',
            id: 1301
          },
          {
            name: 'Property',
            id: 1401
          },
          {
            name: 'Marine Cargo',
            id: 1701
          },

          {
            name: 'Others',
            id: 9000
          },
        ],
        categoryOptions: [
          {
            name: 'Business Package',
            id: 51,//1001
          },
          {
            name: 'Employee Compensation (E.C.)',
            id: 52,//1101
          },
          {
            name: 'Contractors’ All Risks (C.A.R.)',
            id: 53 //1601
          },
          {
            name: 'Motors Fleet / Motor Trade',
            id: 54 //1500
          },
          {
            name: 'Employee Benefits (E.B.)',
            id: 55 //1200
          },
          {
            name: 'Public Liability',
            id: 56 //1301
          },
          {
            name: 'Property',
            id: 57 //1401
          },
          {
            name: 'Marine Cargo',
            id: 58 //1701
          },
          {
            name: 'Others',
            id: 59 //9000
          },
        ],
        industryOptions: [
          {
            name: 'Catering',
            id: 60
          },
          {
            name: 'Pure Office',
            id: 61
          },
          {
            name: 'Retail Shop',
            id: 62
          },
          {
            name: 'Beauty Center',
            id: 63
          },
          {
            name: 'Education Center',
            id: 64
          },
          {
            name: 'Hair Salon',
            id: 65
          },
          {
            name: 'Warehouse',
            id: 66
          },
          {
            name: 'Medical Center',
            id: 67
          },
        ],
        motorsTypeOptions: [
          {
            name: 'Motors Fleet',
            id: 1501
          },
          {
            name: 'Motor Trade',
            id: 1502
          },
        ],
        benefitsTypeOptions: [
          {
            name: 'Group Business Travel',
            id: 1201
          },
          {
            name: 'Group Personal Accident',
            id: 1202
          },
          {
            name: 'Group Medical',
            id: 1203
          },
        ],
      }
    },
    planLevelOptions() {
      return [
        {
          name: 'Premier & Basic',
          id: 0
        },
        {
          name: 'Basic',
          id: 1
        },
        {
          name: 'Premier',
          id: 2
        }
      ]
    },
    consentOptions(){
      return [
        {
          name: 'Not Consent',
          id: 0
        },
        {
          name: 'Consent',
          id: 1
        },
      ]
    },
    lengthOptions(){
      return [
        {
          name: '7 days',
          id: 1
        },
        {
          name: '30 days',
          id: 2
        },
        {
          name: '90 days',
          id: 3
        },
        {
          name: '180 Days',
          id: 4
        },
        {
          name: '365 Days',
          id: 5
        },
      ]
    },
    // 国籍
    nationalityOptions(){
      return this.globalOptions.id_nationality_seq
    },
    creditAction(){
      return this.globalOptions.credit_action
    },
    uploadTypeOptions(){
      let arr = this.ocrTypeOptions||[]
      arr.filter((item,index)=>{
        let {location=[]} = item||{}
        if(location.length<=0)
          delete item.location
      })
      return arr
      // return [
      //   {
      //     id:'id_no',
      //     name:'HKID',
      //     class:[
      //       {
      //         id:'policy_holder',
      //         name:'Policyholder'
      //       },
      //       {
      //         id:'driver_1',
      //         name:'Driver 1'
      //       },
      //       {
      //         id:'driver_2',
      //         name:'Driver 2'
      //       },
      //       {
      //         id:'driver_3',
      //         name:'Driver 3'
      //       },
      //       {
      //         id:'driver_4',
      //         name:'Driver 4'
      //       },
      //       {
      //         id:'domestice_helper_1',
      //         name:'Domestic Helper 1'
      //       },
      //       {
      //         id:'domestice_helper_2',
      //         name:'Domestic Helper 2'
      //       },
      //       {
      //         id:'operatior_1',
      //         name:'Operator 1'
      //       },
      //       {
      //         id:'operatior_2',
      //         name:'Operator 2'
      //       },
      //     ]
      //   },
      //   {
      //     id:'br',
      //     name:'BR',
      //   },
      //   {
      //     id:'driving_license',
      //     name:'Driving License',
      //     class:[
      //       {
      //         id:'driver_1',
      //         name:'Driver 1'
      //       },
      //       {
      //         id:'driver_2',
      //         name:'Driver 2'
      //       },
      //       {
      //         id:'driver_3',
      //         name:'Driver 3'
      //       },
      //       {
      //         id:'driver_4',
      //         name:'Driver 4'
      //       },
      //     ]
      //   },
      //   {
      //     id:'microchip_copy',
      //     name:'Microchip Copy',
      //     class:[
      //       {
      //         id:'pet_1',
      //         name:'Pet 1'
      //       },
      //       {
      //         id:'pet_2',
      //         name:'Pet 2'
      //       },
      //       {
      //         id:'pet_3',
      //         name:'Pet 3'
      //       }
      //     ]
      //   },
      //   {
      //     id:'ncd_proof',
      //     name:'NCD Proof'
      //   },
      //   {
      //     id:'passport',
      //     name:'Passport',
      //     class:[
      //       {
      //         id:'policy_holder',
      //         name:'Policyholder'
      //       },
      //       {
      //         id:'driver_1',
      //         name:'Driver 1'
      //       },
      //       {
      //         id:'driver_2',
      //         name:'Driver 2'
      //       },
      //       {
      //         id:'driver_3',
      //         name:'Driver 3'
      //       },
      //       {
      //         id:'driver_4',
      //         name:'Driver 4'
      //       },
      //       {
      //         id:'domestice_helper_1',
      //         name:'Domestic Helper 1'
      //       },
      //       {
      //         id:'domestice_helper_2',
      //         name:'Domestic Helper 2'
      //       },
      //       {
      //         id:'operatior_1',
      //         name:'Operator 1'
      //       },
      //       {
      //         id:'operatior_2',
      //         name:'Operator 2'
      //       },
      //     ]
      //   },
      //   {
      //     id:'vrd',
      //     name:'VRD',
      //     class:[
      //       {
      //         id:'current',
      //         name:'Current'
      //       },
      //       {
      //         id:'previous',
      //         name:'Previous'
      //       }
      //     ]
      //   }
      // ]
    },
  },
  created() {
    // 檢查是否有遺漏的 options 數據未獲取成功，重新請求一次
    this.checkOptionsData()
  },
  methods: {
    ...mapActions('common', [
      'updateAllOptions',
      'updateGlobalOptions',
      'checkOptionsData',
      'updateExtraOptions',
      'getBankList']),
    formatCardNumber(cardNumber) {
      return  '•'.repeat(cardNumber.length)
    },
    getOptionName(target, id, originData) {
      try {
        let data
        if(originData) {
          data= originData
        }
        else {
          const targetArr = target.split('.')
          data = this[targetArr[0]]
          if(targetArr.length > 1) {
            data = this[targetArr[0]][targetArr[1]]
          }
        }
        let result = ''
        data.some(item => {
          if (item.id == id) {
            result = item.name
            return true
          }
          return false
        })
        return result
      } catch (e) {
        console.log(target)
      }
    },
    getAllOptionName(target, id) {
      return this.mixinHandler().getAllOptionName(target, id)
    },
    getAllOptionName11(target, id) {
      return this.mixinHandler().getAllOptionName(target, id, 11)
    },
    getAllOptionName12(target, id) {
      return this.mixinHandler().getAllOptionName(target, id, 12)
    },
    getAllOptionName13(target, id) {
      return this.mixinHandler().getAllOptionName(target, id, 13)
    },
    getAllOptionName15(target, id) {
      return this.mixinHandler().getAllOptionName(target, id, 15)
    },
    getAllOptionName21(target, id) {
      return this.mixinHandler().getAllOptionName(target, id, 21)
    },
    getAllOptionName22(target, id) {
      return this.mixinHandler().getAllOptionName(target, id, 22)
    },
    getAllOptionName23(target, id) {
      return this.mixinHandler().getAllOptionName(target, id, 23)
    },
    getAllOptionName24(target, id) {
      return this.mixinHandler().getAllOptionName(target, id, 24)
    },
    getAllOptionName25(target, id) {
      return this.mixinHandler().getAllOptionName(target, id, 25)
    },
    getAllOptionName26(target, id) {
      return this.mixinHandler().getAllOptionName(target, id, 26)
    },
    getAllOptionName27(target, id) {
      return this.mixinHandler().getAllOptionName(target, id, 27)
    },
    getAllOptionName29(target, id) {
      return this.mixinHandler().getAllOptionName(target, id, 29)
    },
    getAllOptionName30(target, id) {
      return this.mixinHandler().getAllOptionName(target, id, 30)
    },
    getAllOptionName31(target, id) {
      return this.mixinHandler().getAllOptionName(target, id, 31)
    },
    getGlobalOptionName(target, id, key = 'id') {
      let result = ''
      this.globalOptions[target].some(item => {
        if (item[key] == id) {
          result = item.name
          return true
        }
        return false
      })
      return result
    },
    getOptionData(target, id, originData) {
      let result = {}
      let data = this[target]||[]
      if(originData) {
        data = originData||[]
      }
      if(data.length>0)
        data.some(item => {
          if (item.id == id) {
            result = item
            return true
          }
          return false
        })
      return result
    },
    getAreaName(target, id) {
      let result = ''
      this.allOptions.area[target].some(item => {
        if (item.id == id) {
          result = item.name
          return true
        }
        return false
      })
      return result
    },
    getAreaData(target, id) {
      let result = {}
      this.allOptions.area[target].some(item => {
        if (item.id == id) {
          result = item
          return true
        }
        return false
      })
      return result
    },
    getAllOptionData(target, id) {
      let result = {}
      this.allOptions[target].some(item => {
        if (item.id == id) {
          result = item
          return true
        }
        return false
      })
      return result
    },
    getExText(ex, posi, pol) {
      if (!ex) { return '- -' }
      let result = ''
      if (posi > 0) {
        result = `${OMath.formatMoney(ex, 0)} or 
        ${posi}% of sum insured whichever is the greater`
      }
      else if (pol > 0) {
        result = `${OMath.formatMoney(ex, 0)} or 
        ${pol}% of lost whichever is the greater`
      } else {
        result = `${OMath.formatMoney(ex, 0)}`
      }
      return result
    },
    mixinHandler() {
      return {
        getAllOptionName: (target, id, classId = '') => {
          // 默認電單車
          let result = ''
          let data = this[`allOptions${classId}`][target] || []
          data.some(item => {
            if (item.id == id) {
              result = item.name
              return true
            }
            return false
          })
          return result
        }
      }
    },
    birthMethod(date){
      return date?dayjs(date).format('YYYY-MM-DD'):''
    },
    changeLineData(data){
      return data?data.replace(/\n/g, '<br/>'):'-'
    },
    changeLineText(data){
      return data?data.replace(/\n/g, '<br/>'):''
    },
    formatText(input) {
      if(input)
      {
        const lines = input.split('\n')
        const urlRegex = /(\b(https?:\/\/|www\.)[^\s]+)/g
        return lines.map(line => {
          return line.replace(urlRegex, (match) => {
            const href = match.startsWith('http') ? match : `http://${match}`
            return `<a href="${href}" target="_blank" class="blue">${match}</a>`
          })
        }).join('<br>')
      }
    },
    showHKTime(time){
      if(time)
      {
        return  dayjs(time).format('DD-MM-YYYY HH:mm:ss')
      }else return  ''
    },
    showHKTimeMin(time,isEnd =false){
      if(time)
      {
        let str = isEnd?'DD-MM-YYYY 23:59':'DD-MM-YYYY HH:mm'
        return  dayjs(time).format(str)
      }else return  ''
    },
    showHKDate(time){
      if(time)
      {
        return  dayjs(time).format('DD-MM-YYYY')
      }else return  ''
    },
    showHKMon(time){
      if(time)
      {
        return  dayjs(time).format('MM-YYYY')
      }else return  ''
    },
    isSameRange(rangeA, rangeB){
      const isStartSame = dayjs(rangeA.start).isSame(rangeB.start, 'day')
      const isEndSame = dayjs(rangeA.end).isSame(rangeB.end, 'day')
      return isStartSame && isEndSame
    },
    getSMEOptionName(option,id){
      let result = ''
      if(!option) return result
      option.some(item => {
        if (item.id == id) {
          result = item.name
          return true
        }
        return false
      })
      return result
    },
    getBankOptionName(id){
      let res = ''
      this.bankList.some(item => {
        if(item.bank_code == id){
          res = item.bank_name
        }
      })
      return res
    },
    check18Years(begin, end) {
      if(!begin || !end) return true

      const years18 = dayjs(begin).add(18, 'years').format('YYYY-MM-DD')
      // 結束那一天也算，加一天來判斷
      const endDate = dayjs(end).add(1, 'day').format('YYYY-MM-DD')
      return dayjs(years18).isBefore(endDate)
    },
    today() {
      let date = new Date()
      const tody = dayjs().format('YYYY-MM-DD')
      return tody
    },
    handlerUser(id){
      if(id){
        this.$router.push({
          path:'/accounts/detail',
          query:{
            customer_id:id
          }
        })
      }
    },
    openUrl(url) {
      if(url){
        window.open(url,'_blank')
      }
    },
    getStatusColor(stts_language,option_name) {
      return Object.keys(this[option_name]).find(color =>
        this[option_name][color].includes(stts_language)
      ) || ''
    },
    truncateText(text, maxLength = 20) {
      return text
      // let suffix = text.split('.')[1]
      // if (text.length <= maxLength) return text
      // return text.substr(0, maxLength - 1) + '…'+`${suffix}`
    }
  },
}
